import React, { useState } from 'react';
import { Key } from 'lucide-react';
import Modal from '../ui/Modal';
import PersonalApiKeysModal from '../PersonalApiKeysModal';
import DarstellungWahl from './DarstellungWahl';
import KopfleisteWahl from './KopfleisteWahl';
import DashboardWahl from './DashboardWahl';
import AssistentWahl from './AssistentWahl';
import { useI18n } from '../../utils/i18n';
import './einstellungen.css';

// #567: Persönliche Einstellungen, unter dem Zahnrad oben rechts.
//
// Jeder Abschnitt ist eine eigene kleine Komponente und steht mit einer Zeile
// in ABSCHNITTE. Kopfleiste (#568), Dashboard (#569) und die Lage des
// KayCee-Assistenten (#512) kommen so dazu. Was jemand wegen seiner Rolle
// nicht sieht, blendet `sichtbar(user)` aus, damit der Dialog keine Schalter
// für Dinge anbietet, die es für ihn gar nicht gibt.
//
// Es gibt keinen „Speichern“-Knopf: Jede Änderung geht sofort über die
// Benutzer-Einstellungen (#564), nur mit ihrem eigenen Schlüssel. Ein Knopf,
// der den ganzen Dialog schreibt, würde mit einem älteren Stand eine
// Änderung aus einem zweiten Tab zurückdrehen.

const SprachWahl = () => {
  const { t, lang, setLanguage } = useI18n();
  // Gespeichert wird die Sprache von EinstellungenAbgleich, gleich, wo sie
  // gewählt wurde
  return (
    <select
      id="einst-sprache"
      className="einst-auswahl"
      aria-label={t('einstellungen.sprache', 'Sprache')}
      value={lang}
      onChange={(e) => setLanguage(e.target.value)}
    >
      <option value="de">{t('language.de', 'Deutsch')}</option>
      <option value="en">{t('language.en', 'Englisch')}</option>
      <option value="es">{t('language.es', 'Spanisch')}</option>
    </select>
  );
};

const ApiKeys = () => {
  const { t } = useI18n();
  const [offen, setOffen] = useState(false);
  return (
    <>
      <p className="einst-text">
        {t('einstellungen.apiKeysText', 'Schlüssel für Programme und Agenten, die mit Ihren Rechten auf das Ticketsystem zugreifen.')}
      </p>
      <button type="button" className="btn btn-secondary" onClick={() => setOffen(true)}>
        <Key size={16} aria-hidden="true" />
        {t('einstellungen.apiKeysVerwalten', 'API-Keys verwalten')}
      </button>
      <PersonalApiKeysModal open={offen} onClose={() => setOffen(false)} />
    </>
  );
};

export const ABSCHNITTE = [
  { id: 'darstellung', titel: ['einstellungen.darstellung', 'Darstellung'], Inhalt: DarstellungWahl },
  { id: 'sprache', titel: ['einstellungen.sprache', 'Sprache'], Inhalt: SprachWahl },
  { id: 'kopfleiste', titel: ['einstellungen.kopfleiste', 'Kopfleiste'], Inhalt: KopfleisteWahl },
  { id: 'dashboard', titel: ['einstellungen.dashboard', 'Dashboard'], Inhalt: DashboardWahl },
  { id: 'assistent', titel: ['assistent.titel', 'KayCee-Assistent'], Inhalt: AssistentWahl }, // #512
  { id: 'apiKeys', titel: ['header.myApiKeys', 'Meine API-Keys'], Inhalt: ApiKeys }
];

const EinstellungenDialog = ({ open, onClose, user }) => {
  const { t } = useI18n();
  const abschnitte = ABSCHNITTE.filter((a) => !a.sichtbar || a.sichtbar(user));
  return (
    <Modal open={open} onClose={onClose} title={t('einstellungen.titel', 'Einstellungen')} maxWidth="560px" closeLabel={t('common.close', 'Schließen')}>
      <div className="einst-dialog">
        {abschnitte.map(({ id, titel, Inhalt }) => (
          <section key={id} className="einst-abschnitt" aria-labelledby={`einst-${id}`}>
            <h3 id={`einst-${id}`} className="einst-abschnitt__titel">{t(titel[0], titel[1])}</h3>
            <Inhalt user={user} />
          </section>
        ))}
      </div>
    </Modal>
  );
};

export default EinstellungenDialog;
